// Sector presets for Local Benefits CMS — Prodinvideo SPRL
// Each preset provides a ready-made color palette + tagline template.
// A super_admin can apply a preset in 1 click; logo, city, contacts remain to be filled.

export const BRAND_PRESETS = [
  {
    id: "fitness",
    label: "Salle de fitness",
    emoji: "🏋️",
    description: "Énergie, performance, dépassement. Orange vif + navy profond.",
    swatches: ["#0a0e27", "#ff6b35"],
    config: {
      color_primary: "#0a0e27",
      color_primary_dark: "#05081a",
      color_accent: "#ff6b35",
      color_accent_dark: "#cc4d1e",
      tagline_fr: "Votre performance. Nos partenaires. Un vrai réseau local.",
      tagline_nl: "Uw prestaties. Onze partners. Een echt lokaal netwerk.",
      hero_subtitle_fr: "Le nouveau cercle d'avantages qui connecte les commerçants locaux aux membres actifs de la salle. Chaque séance, plus de valeur.",
      hero_subtitle_nl: "De nieuwe voordelenkring die lokale handelaars verbindt met de actieve leden van de zaal. Elke sessie, meer waarde.",
    },
  },
  {
    id: "health",
    label: "Centre santé / Kiné",
    emoji: "🩺",
    description: "Confiance, sérieux, expertise. Bleu médical + cyan.",
    swatches: ["#0c4a6e", "#0ea5e9"],
    config: {
      color_primary: "#0c4a6e",
      color_primary_dark: "#083349",
      color_accent: "#0ea5e9",
      color_accent_dark: "#0369a1",
      tagline_fr: "Votre santé au centre. Vos avantages au quotidien.",
      tagline_nl: "Uw gezondheid centraal. Uw voordelen elke dag.",
      hero_subtitle_fr: "Parce que prendre soin de soi passe aussi par le quotidien. Nos partenaires locaux soutiennent votre parcours santé.",
      hero_subtitle_nl: "Omdat zorg voor jezelf ook door het dagelijks leven gaat. Onze lokale partners ondersteunen uw gezondheidstraject.",
    },
  },
  {
    id: "wellness",
    label: "Bien-être / Club sport",
    emoji: "🧘",
    description: "Naturel, apaisant, équilibre. Vert forêt + vert tendre.",
    swatches: ["#064e3b", "#84cc16"],
    config: {
      color_primary: "#064e3b",
      color_primary_dark: "#022c1f",
      color_accent: "#84cc16",
      color_accent_dark: "#4d7c0f",
      tagline_fr: "Le bien-être, en vrai. Avec vos commerçants.",
      tagline_nl: "Welzijn, echt. Met uw handelaars.",
      hero_subtitle_fr: "Un écosystème d'avantages naturels et locaux, pensé pour les membres qui prennent soin d'eux et de leur quartier.",
      hero_subtitle_nl: "Een natuurlijk en lokaal voordelen-ecosysteem, voor leden die zorg dragen voor zichzelf en hun buurt.",
    },
  },
  {
    id: "urban",
    label: "Centre sport-santé (actuel)",
    emoji: "⚡",
    description: "Urbain, moderne, audacieux. Navy nuit + lime électrique.",
    swatches: ["#0b1220", "#BFFF00"],
    config: {
      color_primary: "#0b1220",
      color_primary_dark: "#060a12",
      color_accent: "#BFFF00",
      color_accent_dark: "#65a30d",
      tagline_fr: "Avantages locaux réservés à nos membres",
      tagline_nl: "Lokale voordelen voor onze leden",
      hero_subtitle_fr: "Le nouveau cercle d'avantages qui connecte les commerçants locaux aux membres actifs du centre. Visibilité locale, clients fidèles — et c'est gratuit.",
      hero_subtitle_nl: "De nieuwe voordelenkring die lokale handelaars verbindt met de actieve leden van het centrum.",
    },
  },
];

export function getPresetById(id) {
  return BRAND_PRESETS.find((p) => p.id === id) || null;
}
